function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 90,
  height: 60,
  fill: "#2573C2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M66.3972 21.9652C66.3537 21.2385 66.1404 20.5321 65.7746 19.9026C65.4502 19.254 64.873 18.7481 64.1984 18.4886C63.5105 18.1458 62.7484 17.9787 61.9801 18.0022H33.1941L31.1315 24.1835H57.2127L53.0939 36.8186H27.0192L24.9565 43H53.8788C54.7406 42.9751 55.5926 42.8108 56.4019 42.5135C57.2127 42.053 58.1402 41.586 58.9251 40.9374C59.6913 40.3333 60.3836 39.641 60.9877 38.8748C61.487 38.124 61.9128 37.3269 62.259 36.4943L66.0794 24.4819C66.427 23.6915 66.5374 22.8172 66.3972 21.9652Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M41.409 27.6313H26.0626L24 33.3458H39.502L41.409 27.6313Z",
  fill: "white"
});

var SvgDash = function SvgDash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DASH.bc55536a.svg";
export { ForwardRef as ReactComponent };